"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidMoney = exports.isMoney = exports.moneyToString = exports.toMoneyOrUndefined = exports.toMoney = exports.toNumberOrUndefinedFromMoney = exports.toNumberFromMoney = exports.numberFromMoney = void 0;
const core_1 = require("@newfront-insurance/core");
const types_1 = require("./types");
/**
 * Converts a money object to a number by combining units and nanos.
 * @param money money to covert into a number
 * @deprecated use toNumberFromMoney instead.
 */
function numberFromMoney(money) {
    return toNumberFromMoney(money);
}
exports.numberFromMoney = numberFromMoney;
/**
 * Converts a money object to a number by combining units and nanos.
 * @param money money to covert into a number
 */
function toNumberFromMoney(money) {
    // NOTE: For some reason Money objects are sometimes serialized
    // with units and nanos as strings so we need to ensure they're converted
    // back to numbers before manipulating them.
    return parseInt(`${money.units}`, 10) + parseInt(`${money.nanos}`, 10) / 10 ** 9;
}
exports.toNumberFromMoney = toNumberFromMoney;
/**
 * Converts an optional money object to a number by combining units and nanos or undefined if money object is null/undefined.
 * @param money money to covert into a number or undefined
 */
function toNumberOrUndefinedFromMoney(money) {
    if (!isMoney(money)) {
        return undefined;
    }
    return numberFromMoney(money);
}
exports.toNumberOrUndefinedFromMoney = toNumberOrUndefinedFromMoney;
/**
 * Returns a number as a Money object using USD as the default currency
 * @param amount the numeric amount of the money.
 * @param currencyCode the currency of the amount. default to USD.
 */
function toMoney(amount, currencyCode = types_1.CurrencyCode.USD) {
    const sign = Math.sign(amount);
    const absAmount = Math.abs(amount);
    const units = Math.trunc(absAmount);
    const nanos = Math.round((absAmount - units) * 100) * 10 * 1000 * 1000;
    return {
        currencyCode,
        units: units === 0 ? 0 : sign * units,
        nanos: nanos === 0 ? 0 : sign * nanos,
    };
}
exports.toMoney = toMoney;
/**
 * Returns a number as a Money object using USD as the default currency or undefined if amount is null/undefined.
 * @param amount the numeric amount of the money or undefined.
 * @param currencyCode the currency of the amount. default to USD.
 */
function toMoneyOrUndefined(amount, currencyCode = types_1.CurrencyCode.USD) {
    if (amount === undefined || amount === null) {
        return undefined;
    }
    return toMoney(amount, currencyCode);
}
exports.toMoneyOrUndefined = toMoneyOrUndefined;
/**
 * Returns a string that represents the money object using the options if passed.
 * @param money
 * @param options
 */
function moneyToString(money = { currencyCode: types_1.CurrencyCode.USD, units: 0, nanos: 0 }, options = { fractionDigits: 0 }) {
    var _a;
    const amount = (_a = numberFromMoney(money)) !== null && _a !== void 0 ? _a : 0;
    return amount.toLocaleString('en-US', {
        style: 'currency',
        currency: money.currencyCode,
        minimumFractionDigits: options.fractionDigits,
        maximumFractionDigits: options.fractionDigits,
    });
}
exports.moneyToString = moneyToString;
function isMoney(value) {
    return (0, core_1.isObject)(value) && 'units' in value && 'nanos' in value && 'currencyCode' in value;
}
exports.isMoney = isMoney;
/**
 * Same as `isMoney` in the sense that it narrows the input's shape to check if it is `Money`, but
 * it also checks for the following invariants that every valid Money object should maintain:
 *
 * 1. if `units` is positive, `nanos` must be positive or zero.
 * 2. If `units` is zero, `nanos` can be positive, zero, or negative.
 * 3. If `units` is negative, `nanos` must be negative or zero.
 */
function isValidMoney(value) {
    if (!isMoney(value)) {
        return false;
    }
    const { units, nanos } = value;
    if (units > 0) {
        return nanos >= 0;
    }
    if (units < 0) {
        return nanos <= 0;
    }
    return true;
}
exports.isValidMoney = isValidMoney;
//# sourceMappingURL=utils.js.map